import { useBusinessModalContext as s } from "../../../BusinessModalContext.js";
const r = () => {
  const {
    preFilters: e
  } = s();
  return {
    groups: e?.selectedGroupIds?.join(",")
  };
};
export {
  r as useGetGroups
};
